export default __webpack_public_path__ + "static/media/icon-download.1e863f7e.svg";